import { isString } from 'lodash';
import { OpenAI } from 'openai';
import { isObject } from './common';
import { TypeGuard } from './type-guards';

/**
 * The chat model the server's OpenAI calls use, shared so they don't drift
 * apart. Not typed as `OpenAI.ChatModel`: the installed SDK's model union
 * predates gpt-4.1, while a request's `model` accepts any model name.
 */
export const OPEN_AI_CHAT_MODEL = 'gpt-4.1-mini';

export interface IOpenAIQueryData {
  model: OpenAI.ChatModel;
  messages: OpenAI.ChatCompletionMessageParam[];
  jsonSchema: OpenAI.ResponseFormatJSONSchema['json_schema']['schema'];
}

export function isOpenAIQueryRequest(
  data: IOpenAIQueryData
): data is IOpenAIQueryData {
  return TypeGuard.interface<IOpenAIQueryData>({
    model: isString,
    messages: TypeGuard.arrayOf(
      TypeGuard.interface<OpenAI.ChatCompletionMessageParam>({
        role: isString,
        content: isString,
      })
    ),
    jsonSchema: isObject,
  })(data);
}
